import mixpanel from 'mixpanel-browser'
import firebase from 'firebase/app'
const isProd = process.env.NODE_ENV === 'production'

// export const getAnalyticsConfig = router => {
//   return {
//     id: process.env['VUE_APP_GOOGLE_ANALYTICS_ID'],
//     router,
//     autoTracking: {
//       exception: true
//     },
//     debug: {
//       // enabled: !isProd,
//       sendHitTask: isProd
//     }
//   }
// }

export const initMixpanel = () => {
  if (isProd) {
    mixpanel.init(process.env['VUE_APP_MIXPANEL_API_TOKEN'])
    // mixpanel.set_config({ debug: true })
  }
}

export const trackEvent = (event, data = {}) => {
  if (isProd) {
    // Send event to Mixpanel
    mixpanel.track(event, data)
    // Send event to Google
    if (data && Object.keys(data).length > 0) {
      Object.keys(data).forEach(key => {
        data[key] = data[key].toLowerCase()
      })
      // if (window.ga) window.ga('send', data)
      firebase.analytics().logEvent(event, data)
    }
  }
}

export const identifyUser = user => {
  if (isProd) {
    mixpanel.identify(user)
    firebase.analytics().setUserId(user)
  }
}
